import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReuploadOrder } from '@core/models/reupload-order.model';
import { environment } from '@environment/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ReuploadService {
  constructor(private httpClient: HttpClient) {}
  getNotDoneOrders() {
    const route = `${environment.examInfoBackend}/lis/integration_updates/not_done_reupload_orders`;
    return this.httpClient.get<ReuploadOrder[]>(route);
  }

  sendImageReuploadOrder(image_barcode: string) {
    const route = `${environment.examInfoBackend}/lis/integration_updates/reupload_image/${image_barcode}`;
    return this.httpClient
      .post(route, {})
      .pipe(catchError((error) => throwError(() => error)));
  }

  sendExamReuploadOrder(code: string) {
    const route = `${environment.examInfoBackend}/lis/integration_updates/reupload_exams/${code}`;
    return this.httpClient
      .post(route, {})
      .pipe(catchError((error) => throwError(() => error)));
  }
}
